import { type HTMLAttributes, type ReactNode } from 'react';

export function FloatingPanel({ children, className = '', ...props }: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return <div {...props} className={`dd-floating-panel ${className}`.trim()}>{children}</div>;
}
